import { useMutation, useQueryClient } from "@tanstack/react-query";
import { serviceTemplateService } from "../../../services/serviceTemplatesService";

export const useDeleteServiceTemplate = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceTemplateId,
    }: {
      serviceTemplateId: string;
    }) => {
      const deleted = await serviceTemplateService.delete(serviceTemplateId);
      if (!deleted) {
        throw new Error(
          `Service template with id "${serviceTemplateId}" not found`,
        );
      }
      return { deleted, serviceTemplateId };
    },
    onSuccess: ({ serviceTemplateId }) => {
      qc.invalidateQueries({ queryKey: ["service-template", serviceTemplateId] });
      qc.invalidateQueries({ queryKey: ["service-templates"] });
    },
  });
};
